import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/getUserInfoByToken', request)
}

export {get}
